// export const auth0Namespace = 'https://sprintray.com/';
// export const auth0Namespace = 'https://getneer.com/';
export const auth0Namespace = 'https://sprintray.com/'; // TODO: replace with the correct namespace

export const ClaimKeys = {
    userId: 'sub',
    avatarUrl: 'picture',
    permissions: 'permissions',
    app_metadata: auth0Namespace + 'app_metadata',
    email: auth0Namespace + 'email',
    email_verified: auth0Namespace + 'email_verified',
    roles: auth0Namespace + 'roles',
    registrationCompleted: auth0Namespace + 'reg_completed',
    emailVerified: auth0Namespace + 'email_verified',
    stripeCustomerId: auth0Namespace + 'stripe_customer_id',
    isPromoUser: auth0Namespace + 'is_promo_user',
    organizationId: auth0Namespace + 'organization_id',
    officeId: auth0Namespace + 'office_id',
    canSubmitTreatment: auth0Namespace + 'can_submit_treatment',
    orgRegionId: auth0Namespace + 'org_region_id',
    isSeniorAdvisor: auth0Namespace + 'senior_advisor',
    region: auth0Namespace + 'region',
    source: auth0Namespace + 'source',
    treatmentLimits: auth0Namespace + 'treatment_limits',
};
